import React from "react";

interface NextBarProps {
  handleSelect: () => void;
  disabled?: boolean;
}

const NextBar: React.FC<NextBarProps> = ({ disabled, handleSelect }: NextBarProps) => {
  const cn =
    "bg-blue-600 hover:bg-blue-700 text-white font-medium py-2 px-6 rounded-lg transition-colors";
  const disabledCn = "bg-gray-300 text-gray-500 cursor-not-allowed";
  return (
    <div className="border-t border-gray-200 px-8 py-4 flex justify-center">
      <button
        type="submit"
        onClick={handleSelect}
        className={disabled ? cn + " " + disabledCn : cn}
        disabled={disabled}
      >
        Next
      </button>
    </div>
  );
};

export default NextBar;